import * as React from 'react';
import styles from './tooltip.scss';

export interface TooltipProps {
  title?: string;
  center?: boolean;
  narrow?: boolean;
  delayed?: boolean;
  className?: string;
  direction?: TooltipDirections;
  onClick?: () => void;
}

export enum TooltipDirections {
  default,
  top,
  left,
  right,
  bottom
}

export class Tooltip extends React.Component<TooltipProps, any> {
  public splitTooltip(text: string) {
    // Two ways for detecting the line breaks
    if (text.indexOf('\n') > -1) {
      return text.split('\n');
    }
    return text.split('\\n');
  }

  public render() {
    const {title, children, className, onClick, center, narrow, delayed, direction} = this.props;

    const tooltip = <div className={`tooltip-text ${styles.tooltiptext}`}>
      {title && this.splitTooltip(title).map((text, index) => <p key={index}>{text}</p>)}
    </div>;

    const classNames = [
      styles.tooltip,
      className,
      center && styles.center,
      narrow && styles.narrow,
      delayed && styles.delayed,
      (direction && direction === TooltipDirections.left) && styles.left,
      (direction && direction === TooltipDirections.right) && styles.right,
      (direction && direction === TooltipDirections.top) && styles.top,
      (direction && direction === TooltipDirections.bottom) && styles.narrow
    ].filter(item => item);

    return (<div className={classNames.join(' ')} onClick={onClick}>
      {children}
      {!!title && <div className={`${styles.tooltipArrow}`} />}
      {!!title && tooltip}
    </div>);
  }
}
